export default __webpack_public_path__ + "static/icon-6-4-af8a35997fa34b6ed7c1bf8c72b15b4c.png";